import React from "react";

export default function ChangeCookieSettings() {
  return (
    <div className="page">
      <h1>Change Cookie Settings</h1>
      <p>Change cookie settings content placeholder.</p>
    </div>
  );
}
